
  $(document).ready(function() {
    // $('.custom-option-field').on('input', function() {
    //     const inputValue = $(this).val();
    //     var dd = $(this).attr('id');
    //   console.log('id ',dd)
    //     $('input.product-form-hidden-line-properties[data-custom-option-target="' + dd + '"]').val(inputValue);
    // });

    // function getCheckedRadioValue() {

    //   if ($('input[value="CUSTOM"].js-option:checked').length > 0) {
    //         console.log("The selected option contains 'custom'");
    //         $('.ar-customization-option').addClass('visible-element');
    //     } else {
    //         console.log("The selected option does not contain 'custom'");
    //         $('.ar-customization-option').removeClass('visible-element');
    //         $('.custom-product-option .custom-option-field').val('');
    //         $('.product-customization-hidden-field').val('');
    //     }
    //         if ($('input[value="Custom"].js-option:checked').length > 0) {
    //         console.log("The selected option contains 'custom'");
    //         $('.ar-customization-option').addClass('visible-element');
    //     } else {
    //         console.log("The selected option does not contain 'custom'");
    //         $('.ar-customization-option').removeClass('visible-element');
    //         $('.custom-product-option .custom-option-field').val('');
    //         $('.product-customization-hidden-field').val('');
    //     }
    //     // console.log('Selected Radio Value:', selectedValue);
    // }
    // getCheckedRadioValue();
//     $('.option-selector__btns .js-option').on('change', function() {
//       setTimeout(function(){
//         console.log('radio changed')
//         getCheckedRadioValue();
//         },10)
//     });
  
//    $('.custom-product-option .custom-option-field').on('input', function() {
//         this.value = this.value.replace(/[^0-9]/g, '');
//     });

// $('.coupon-apply').click(function() {
//     var textToCopy = $(this).attr('data-coupen-code');
//     var $tempTextarea = $('<textarea>');
//     $('body').append($tempTextarea);
//     $tempTextarea.val(textToCopy).select();
//     document.execCommand('copy');
//     $tempTextarea.remove();
// });
  
// $(document).on('click', function (e) {
//     if(!$(e.target).closest('.ticket-coupon-container').length && !$(e.target).closest('.js-cart-drawer').length) {
//        console.log('yes');
//       $('.ticket-coupon-container').removeClass('open');
//     }  
// });

//   $('.show-coupen-details').on('click', function () {
//       let aaa = this;
//     const contentDiv = $(this).next();
//     contentDiv.slideToggle(200,function(){
//          $(aaa).toggleClass('active');
//     });
//   });  


    
// code fo complete the look product add to cart start here 

     let option_variant_value;   
   function variantChange(option_1,option_2,option_3){       
       if(typeof option_1 != 'undefined' && typeof option_2 != 'undefined' && typeof option_3 != 'undefined'){
         option_variant_value = option_1 + " / " + option_2 + " / " + option_3;
       }else{
           if(typeof option_1 != 'undefined' && typeof option_2 == 'undefined' && typeof option_3 == 'undefined'){
               option_variant_value = option_1;
             }else{
               if(typeof option_1 != 'undefined' && typeof option_2 != 'undefined' && typeof option_3 == 'undefined'){
                   option_variant_value = option_1 + " / " + option_2;
                 }
             }
           if(typeof option_1 == 'undefined' && typeof option_2 != 'undefined' && typeof option_3 == 'undefined'){
               option_variant_value = option_1;
             }else{
               if(typeof option_1 != 'undefined' && typeof option_2 != 'undefined' && typeof option_3 != 'undefined'){
                   option_variant_value = option_2 + " / " + option_3;
                 }
             }
           if(typeof option_1 == 'undefined' && typeof option_2 == 'undefined' && typeof option_3 != 'undefined'){
               option_variant_value = option_1;
             } else{
               if(typeof option_1 != 'undefined' && typeof option_2 == 'undefined' && typeof option_3 != 'undefined'){
                   option_variant_value = option_1 + " / " + option_3;
                 }
             }
       }           
        console.log('option data = '+ option_variant_value)
       $('.variant-option-js option').each(function(){
           if($(this).text() == option_variant_value){
               $(this).prop('selected',true);

              let selected_pro_id = $(this).attr('data-id'); 
              console.log(selected_pro_id);             
              $('.cl-add-to-cart').attr('product_selected_id',selected_pro_id);                                                   
              let regular_price = $(this).attr('data-price');
              let comp_price = $(this).attr('data-compate-price');
              let discount_percentage = $(this).attr('data-discount-percentage');
             var comparestatus = $(this).attr('isvariantcomparepice');
             console.log('sdf -- ',comparestatus);
             console.log(typeof comparestatus);
             setTimeout(function(){
              if(comparestatus == "true"){
              $('.cl-regular-price').html(regular_price);
              $('.cl-compare-price').html(comp_price); 
              $('.cl-badge').html(discount_percentage); 
               $('.cl-compare-price').show();
               $('.cl-badge').show(); 
              }else if(comparestatus == "false"){
               $('.cl-compare-price').hide();
               $('.cl-badge').hide(); 
              } 
               },100)

              let item_quantity = $(this).attr('data-inventroty');
              let data_countinue_selling = $(this).attr('data-countinue-selling'); 
              if(item_quantity == 0 && data_countinue_selling == 'false' ){
                $('.cl-add-to-cart').prop("disabled", true); 
                $('.cl-add-to-cart').text('SOLD OUT');
              }else{
                $('.cl-add-to-cart').prop("disabled", false); 
                $('.cl-add-to-cart').text('ADD TO CART')         
              }              
           }
       })
      }
       
    $(document).on("change", "input[type=radio][name=product-page-option-1]", function() {
      console.log('dfgbhgfdfs')
        let option_1 = $("input[type=radio][name='product-page-option-1']:checked").val(),
          option_2 = $("input[type=radio][name='product-page-option-2']:checked").val(),
          option_3 = $("input[type=radio][name='product-page-option-3']:checked").val();
       variantChange(option_1, option_2, option_3)
    })

    $(document).on("change", "input[type=radio][name=product-page-option-2]", function() {
        let option_2 = $("input[type=radio][name='product-page-option-2']:checked").val(),
           option_1 = $("input[type=radio][name='product-page-option-1']:checked").val(),
          option_3 = $("input[type=radio][name='product-page-option-3']:checked").val();
       variantChange(option_1, option_2, option_3)
    })
    $(document).on("change", "input[type=radio][name=product-page-option-3]", function() {
        let option_3 = $("input[type=radio][name='product-page-option-3']:checked").val(),
           option_2 = $("input[type=radio][name='product-page-option-2']:checked").val(),
          option_1 = $("input[type=radio][name='product-page-option-1']:checked").val();
       variantChange(option_1, option_2, option_3)
    })
  if($('.complete-the-look-section .cl-add-to-cart').length > 0){ 
document.querySelector(".cl-add-to-cart").addEventListener("click", (event) => {
  console.log('sfdgfc')
var cl_add_product_id = $(".cl-add-to-cart").attr('product_selected_id');
  var cl_add_prduct_qty = $('.cl-info-section .qty__input--product').val();
let formData = {
 'items': [{
  'id': cl_add_product_id,
  'quantity': cl_add_prduct_qty
  }]
};
fetch(window.Shopify.routes.root + 'cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(formData)
})
.then(response => {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
    setTimeout(function(){
      $('.header__cart-count').trigger('click')
    },500)
})
.catch((error) => {
  console.error('Error:', error);
}); 
  })
}  

  // code for complete the loop product qunatity selector start here 


     $(document).on("click", ".cl-info-section .quantity_field .js-qty-add", function(e) {
        $(this).prev().val(+$(this).prev().val() + 1);
    })
   $(document).on("click", ".cl-info-section .quantity_field .js-qty-minus", function(e) {
        $(this).next().val() > 1 && $(this).next().val(+$(this).next().val() - 1);
    })
 $(document).on("keyup change click", ".cl-info-section .quantity_field .qty__input", function(e) {
     if($(this).val() == "" || $(this).val() == "0"){
        $(this).val(1);
     }
})
  
  // code for complete the loop product qunatity selector end here


// code for complete the look product add to cart end here 

// coupon code in cart drawer code start here

$(document).on("click",".coupon-bar-inner",function() {
    console.log('first')
    $(this).parents('.mini-cart').find('.ticket-coupon-container').addClass('open');
    console.log('df')
})
$(document).on("click",".back-to-coupen svg",function() {
    $(this).parents('.mini-cart').find('.ticket-coupon-container').removeClass('open');
})
  
  function getScrollAmount() {
    const container = document.getElementById('couponWrapper');
    if (window.innerWidth >= 768) {
      return container.clientWidth * 0.29; // 29% for desktop
    } else {
      return container.clientWidth * 0.43; // 43% for mobile
    }
  }

  function scrollLeft() {
    const container = document.getElementById('couponWrapper');
    container.scrollBy({
      left: -getScrollAmount(),
      behavior: 'smooth'
    });
  }

  function scrollRight() {
    const container = document.getElementById('couponWrapper');
    container.scrollBy({
      left: getScrollAmount(),
      behavior: 'smooth'
    });
  }

  // Make sections draggable on desktop and mobile
  const couponWrapper = document.getElementById('couponWrapper');

  let isDown = false;
  let startX;
  let scrollLeftStart;

  couponWrapper.addEventListener('mousedown', (e) => {
    isDown = true;
    couponWrapper.classList.add('active');
    startX = e.pageX - couponWrapper.offsetLeft;
    scrollLeftStart = couponWrapper.scrollLeft;
  });

  couponWrapper.addEventListener('mouseleave', () => {
    isDown = false;
    couponWrapper.classList.remove('active');
  });

  couponWrapper.addEventListener('mouseup', () => {
    isDown = false;
    couponWrapper.classList.remove('active');
  });

  couponWrapper.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - couponWrapper.offsetLeft;
    const walk = (x - startX) * 2; // scroll-fast
    couponWrapper.scrollLeft = scrollLeftStart - walk;
  });
    
    $(document).on("click",".coupon-apply",function() {
    var textToCopy = $(this).attr('data-coupen-code');
    var $tempTextarea = $('<textarea>');
    $('body').append($tempTextarea);
    $tempTextarea.val(textToCopy).select();
    document.execCommand('copy');
    $tempTextarea.remove();
});
  
$(document).on('click', function (e) {
    if(!$(e.target).closest('.ticket-coupon-container').length && !$(e.target).closest('.mini-cart').length) {
       console.log('yes');
      $('.ticket-coupon-container').removeClass('open');
    }  
});

  $(document).on("click",".show-coupen-details",function() {  
      let aaa = this;
    const contentDiv = $(this).next();
    contentDiv.slideToggle(200,function(){
         $(aaa).toggleClass('active');
    });
  });  
// coupon code in cart drawer code end here

});
